module.exports = __webpack_public_path__ + "img/563.2182f272.jpg";